'use client';

import { useQuery } from '@tanstack/react-query';

import { devQueryKeys, fetchStableBuildStatus } from '@/lib/api/dev/stable-build';
import type { StableBuildStatus } from '@/lib/schemas/dev/stable-build.schema';

// État du frontend stable, pour le bouton « Recompiler » de dev. Suivi toutes les 3 s pendant une
// recompilation, toutes les minutes sinon. `null` quand la route n'est pas ouverte à cet
// utilisateur ou sur cet hôte : le bouton ne s'affiche pas.
export function useStableBuildStatus(enabled: boolean) {
  return useQuery({
    queryKey: devQueryKeys.stableBuild(),
    queryFn: async (): Promise<StableBuildStatus | null> => {
      const res = await fetchStableBuildStatus();
      return res.ok ? res.status : null;
    },
    enabled,
    refetchInterval: (query) => {
      const state = query.state.data?.state;
      return state === 'building' || state === 'requested' ? 3000 : 60_000;
    },
  });
}
